import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'
import { RightsWrapper } from '../../../components/_utils/utils'
import PDFFileView from '../../../components/DocumentViews/PDFFileView'
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const TabPane = Tabs.TabPane
@Form.create()

class AllConsortium extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    isAgreementExpire: false,
    ext: null,
    linkUrl: null,
    agreement: []
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      let data = await Request.getConsortiumsDetails({
        ...params,
        regExFilters: []
      })
      this.setState({ total: data.total })
      resolve(data)
    })
  }
  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateConsortiumDetails(values)
        } else {
          x = await Request.addConsortiumDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Consortium Updated Successfully`
              : 'Consortium Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deleteConsortiumDetails = async data => {
    this.setState({ loading: true })
    await Request.deleteConsortiumDetails(data)

    this.setState({ loading: false })

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  setConsortiumDetailsData(consortiumId) {
    if (consortiumId) {
      Request.consortiumDetailsByID({ id: consortiumId }).then(
        ({ doc, error, message }) => {
          if (!error && doc) {
            this.setState({
              id: doc._id,
              activeTab: '1',
              isAgreementExpire: doc && doc.isAgreementExpire
            })

            this.props.form.setFieldsValue({
              consortiumName: doc.consortiumName,
              paymentUpload: doc && doc.paymentUpload,
              agreementSigningDate: doc && moment(doc.agreementSigningDate),
              paymentUploadCommissionPage: doc && doc.paymentUploadCommissionPage,
              isAgreementExpire: doc && doc.isAgreementExpire,
              enrollmentExpiry: doc && moment(doc.enrollmentExpiry)
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  componentWillMount() {

  }

  checkUrlExt = (url) => {
    return url.split(/[#?]/)[0].split('.').pop().trim();
  }

  closeDocument = () => {
    this.setState({ ext: null, linkUrl: null, agreement: [] });
  }


  viewPDF = e => {
    const { paymentUpload } = e;
    // const { form, serviceData, partnershipArr } = this.props;
    // const { agreement } = serviceData;
    if (paymentUpload.length > 0) {
      let linkUrl = MEDIA_URL + paymentUpload[0].url;
      let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
      if (this.checkUrlExt(linkUrl)) {
        this.setState({ ext: ext, linkUrl: linkUrl, agreement: paymentUpload });
      } else {
        notification.warning({
          message: 'Agreement not exists!!!.'
        })
      }
    }
  }

  viewCommPDF = e => {
    const { paymentUploadCommissionPage } = e;
    // const { form, serviceData, partnershipArr } = this.props;
    // const { agreement } = serviceData;
    if (paymentUploadCommissionPage.length > 0) {
      let linkUrl = MEDIA_URL + paymentUploadCommissionPage[0].url;
      let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
      if (this.checkUrlExt(linkUrl)) {
        this.setState({ ext: ext, linkUrl: linkUrl, agreement: paymentUploadCommissionPage });
      } else {
        notification.warning({
          message: 'Agreement not exists!!!.'
        })
      }
    }
  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  render() {
    const { dispatch } = this.props
    const {
      form: { getFieldDecorator, setFieldsValue }
    } = this.props
    const { id, ext, linkUrl, agreement } = this.state;

    const inputTypes = {
      fields: [
        {
          label: 'Consortium Name',
          key: 'consortiumName',
          required: true
        },
        {
          label: "Agreement",
          key: "paymentUpload",
          type: "file",
          required: true,
        },
        {
          label: 'Agreement Commission Page Document',
          key: 'paymentUploadCommissionPage',
          type: 'file',
          required: true,
        },
        {
          label: 'Signing Date',
          key: 'agreementSigningDate',
          required: true,
          type: 'date',
          format: 'DD-MMM-YYYY'
        },
        {
          label: 'Does This Agreement has Expiry?',
          key: 'isAgreementExpire',
          default: false,
          required: true,
          type: 'switch',
          onChange: checked => {
            this.setState({ isAgreementExpire: checked }, () => {
              setFieldsValue({ isAgreementExpire: checked })
            })
          }
        },
        {
          label: 'Expiry Date',
          key: 'enrollmentExpiry',
          hidden: this.state.isAgreementExpire ? false : true,
          required: this.state.isAgreementExpire ? true : false,
          type: 'date',
          format: 'DD-MMM-YYYY'
        },
      ]
    };

    const columns = [
      {
        title: 'Consortium Name',
        key: 'consortiumName',
      },
      {
        title: 'Agreement',
        key: 'paymentUpload',
        render: (text, record) => (
          record.paymentUpload && record.paymentUpload.length > 0 ?
            <Button type='primary' icon='eye' onClick={() => this.viewPDF(record)} />
            : null
        )
      },
      {
        title: 'Agreement Commission Page',
        key: 'paymentUploadCommissionPage',
        render: (text, record) => (
          record.paymentUploadCommissionPage && record.paymentUploadCommissionPage.length > 0 ?
            <Button type='primary' icon='eye' onClick={() => this.viewCommPDF(record)} />
            : null
        )
      },
      {
        title: 'Signing Date',
        key: 'agreementSigningDate',
        render: (text, record) => (
          record.agreementSigningDate ? moment(record.agreementSigningDate).format(dateFormat) : null
        )
      },
      {
        title: 'Expiry Date',
        key: 'enrollmentExpiry',
        render: (text, record) => (
          record.enrollmentExpiry ? moment(record.enrollmentExpiry).format(dateFormat) : null
        )
      },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'Consortiums.edit'}>
              <Tooltip title="Edit Consortium">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setConsortiumDetailsData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'Consortiums.delete'}>
              <Tooltip title="Delete Consortium">
                <Popconfirm
                  title="Are you sure delete this Consortium?"
                  onConfirm={() => {
                    this.deleteConsortiumDetails({ _id: record._id })
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Consortium Details `}>
        {
          ext != null && agreement.length > 0 ?
            <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
            : null
        }
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Consortiums`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 900 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>

            <TabPane tab={(id ? 'Edit' : 'Add') + ' Consortium'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  apiurl={LAPI_URL}
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}

                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllConsortium
